import { escapeSingleQuotes } from "../odata-string-utils.ts";
import { Expression } from "./base/Expression.ts";
import type { PropertyInfo } from "./base/types.ts";
import type { PropertyExpression } from "./PropertyExpression.ts";

export class InExpression extends Expression {
    readonly type = "in";
    public property: PropertyExpression;
    public values: (string | number)[];

    constructor(property: PropertyExpression, values: (string | number)[]) {
        super();
        this.property = property;
        this.values = values;

        if (values.length === 0) {
            throw new Error("InExpression requires at least one value");
        }
    }

    stringify(): string {
        const left = this.property.stringify();
        const values = this.values
            .map(v => (typeof v === "string" ? `'${escapeSingleQuotes(v)}'` : v.toString()))
            .join(", ");
        return `${left} in (${values})`;
    }

    getKey(): string {
        return `in::${this.property.toPathString()}::${this.values.join(",")}`;
    }

    getPropertyInfo(): PropertyInfo {
        return this.property.getPropertyInfo();
    }
}
